import { styled } from '@mui/material/styles';
import { theme } from '@unicorn/bms-theme';

export const Container = styled('div')(() => ({
  flex: '1 1 0',
  maxHeight: '100%',
  overflow: 'auto',

  '& > .controls-vertical': {
    padding: '24px',
    minHeight: '100%',
  },

  '& .controls-vertical': {
    gap: '24px',
  },

  '& .controls-horizontal': {
    gap: '24px',
  },

  '& .collapse': {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '8px',
    padding: '12px 16px',
  },
}));

export const Actions = styled('div')`
  display: flex;
  padding: 24px;
  justify-content: space-between;
  position: relative;
`;

export const ActionsLeft = styled('div')`
  display: inline-flex;
  gap: 12px;
`;

export const ActionsRight = styled('div')`
  display: inline-flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const PaddingContainer = styled('div')`
  padding: 24px;
`;
